export const Add = "add";
export { Home } from "@/shared/route-names";
export const AdvisorRule3 = "advisorRule3";
export const AdvisorRuleList3 = "advisorRuleList3";
export const AdvisorActionList3 = "advisorActionList3";
export const AdminEmailChange = "adminEmailChange";
export const AdminDobNameChange = "adminDobNameChange";
export const AdminDobNameChangeUsers = "adminDobNameChangeUsers";
export const LinkedBankAccountManagement = "linkedBankAccountManagement";
export const Employers = "employers";
export const Employer = "employer";
export const Partners = "partners";
export const PartnerDetails = "partnerDetails";
export const PartnerUsers = "partnerUsers";
export const PartnerUserAdd = "partnerUserAdd";
export const PartnerCustomization = "partnerCustomization";
export const PartnerSettingsPage = "partnerSettingsPage";
export const Reports = "reports";
export const Utility = "utility";
export const AdminUtilityUserEnableDisableAccount = "adminUtilityUserEnableDisableAccount";
export const AdminUtilityReindexUser = "adminUtilityReindexUser";
export const AdminUtilityFraudCheckQueue = "adminUtilityFraudCheckQueue";
export const AdminUtilityMfaDisable = "adminUtilityMfaDisable";
export const AdminUtilityPendingTx = "adminUtilityPendingTx";
export const AdminUtilityOpenSearch = "adminUtilityOpenSearch";
export const AdminUtilityStateMachine = "adminUtilityStateMachine";
export const AdminUtilityInstantTransferFailures = "adminUtilityInstantTransferFailures";
export const AdminUtilityReimbursementFailures = "adminUtilityReimbursementFailures";
export const AdminUtilityUmbDeleteLinkedAccount = "adminUtilityUmbDeleteLinkedAccount";
export const AdminSftpTestFiles = "adminSftpTestFiles";
export const AdminPasswordReset = "adminPasswordReset";
export const FraudCheckDetail = "fraud-check-detail";
export const ResetUserCustodian = "reset-user-custodian";
export const ReportsAdminBillingDetail = "reportsAdminBillingDetail";
export const ReportsAdminBillingEmployeeFees = "reportsAdminBillingEmployeeFees";
export const ReportsAdminBillingSummary = "reportsAdminBillingSummary";
export const ReportsAdminFraudPrevention = "reportsAdminFraudPrevention";
export const ReportsAdminDemoUsers = "reportsAdminDemoUsers";
export const Security = "security";
export const SalesPersons = "salesPersons";
export const SalesPersonAddEdit = "salesPersonAddEdit";
export const PersonalContributionQueue = "PersonalContributionQueue";
export const TransactionEdit = "TransactionEdit";
export const EmployerRolePermissions = "EmployerRolePermissions";
export const QuickSightReportManage = "QuickSightReportManage";
export const QuickSightReportsList = "QuickSightReportsList";
export const AdvisorAction = "advisorAction";
export const AdvisorRuleHelp = "advisorRuleHelp";
export const SigningDocuments = "signingDocuments";
export const SigningDocumentEditor = "signingDocumentEditor";
export const RiskQuizAgePortfolio = "riskQuizAgePortfolio";
export const RiskQuizAgeRevision = "riskQuizAgeRevision";
export const InstrumentList = "instrumentList";
export const CardCustomization = "cardCustomization";
export const CardCustomizationBulkImport = "cardCustomizationBulkImport";
export const ReopenAccountUtility = "reopenAccountUtility";
export const ReopenAccountUtilityUsers = "reopenAccountUtilityUsers";
export const OutageNotificationConfiguration = "outageNotificationConfiguration";
export const AdminTestUsers = "adminTestUsers";
export const AdminFinicityLinkedAccountsUsers = "adminFinicityLinkedAccountsUsers";
export const AdminFinicityLinkedAccounts = "adminFinicityLinkedAccounts";
export const ManageThemes = "manageThemes";
export const ManageTheme = "manageTheme";
export const MobileAppList = "mobileAppList";
export const ManageMobileApp = "manageMobileApp";
export const DemoConfig = "demoConfig";
export const TransferOutCampaigns = "transferOutCampaigns";
export const CreateCampaign = "createCampaign";
export const ViewEditCampaign = "viewEditCampaign";
export const RolePermissions = "rolepermissionlist";
export const OmnibusTransactionCodeManagement = "omnibusTransactionCodeManagement";
export const RoleAdd = "roleadd";
export const RoleEdit = "roleedit";
export const DWInstrument = "dwInstrument";
export const WexDisableLegacyInvestment = "wexDisableLegacyInvestment";
export const AdminUserManagement = "adminUserManagement";
export const CreateAdminUser = "createAdminUser";
export const EditAdminUser = "editAdminUser";
export const HsabCpfBlackoutManagement = "HsabCpfBlackoutManagement";
export const RepointInvestmentAccount = "RepointInvestmentAccount";
export const InvestmentAccountSearch = "InvestmentAccountSearch";
export const RepointInvestmentRequests = "RepointInvestmentRequests";
export const InvestmentAccountClose = "InvestmentAccountClose";
export const PartnerUserBulkActions = "PartnerUserBulkActions";
export const PartnerUserBulkMassAdd = "MassAdd";
export const PartnerUserBulkMassDelete = "MassDelete";
export const ConsumerDetail = "ConsumerDetail";
export const ConsumerSearch = "ConsumerSearch";